import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/home/main_image_default.png';
import _imports_1 from '@/assets/images/icons/member_code.svg';
var _hoisted_1 = {
  class: "banner"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 1,
  class: "banner-img",
  src: _imports_0,
  alt: ""
};
var _hoisted_4 = {
  class: "member"
};
var _hoisted_5 = {
  class: "content"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = {
  class: "desc"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "title"
};
var _hoisted_11 = {
  class: "desc"
};
var _hoisted_12 = {
  class: "member"
};
var _hoisted_13 = {
  class: "name van-ellipsis"
};
var _hoisted_14 = {
  class: "tag"
};
var _hoisted_15 = {
  class: "assets"
};
var _hoisted_16 = {
  class: "num"
};
var _hoisted_17 = {
  class: "unit"
};
var _hoisted_18 = {
  class: "val"
};
var _hoisted_19 = {
  class: "label"
};
var _hoisted_20 = {
  class: "val"
};
var _hoisted_21 = {
  class: "label"
};
var _hoisted_22 = {
  class: "val"
};
var _hoisted_23 = {
  class: "label"
};
var _hoisted_24 = {
  key: 0,
  class: "logo"
};
var _hoisted_25 = ["src"];
import { ref, computed, onActivated } from "vue";
import { useRouter } from "@/hooks/useRouter";
import { useAddress } from "@/hooks/useAddress";
import { useShopStore } from "@/store/shopStore";
import { useSupplierStore } from "@/store/supplierStore";
import { useUserStore } from "@/store/userStore";
import { OrderTypeEnum } from "@/constant/order";
import { priceUtil } from "@op/shared";
import { PriceStrCurrencySymbolEnum } from "@/constant/currency";
import StickyPowerBy from "@/components/StickyPowerBy.vue";
import LastestOrderPanel from "@/components/order/LastestOrderPanel.vue";
import accountAvatar from "@/assets/images/default_avatar.png";
import Image from "@/components/base/Image.vue";
import SvgIcon from "@/components/base/SvgIcon.vue";
import { useOrder } from "@/hooks/useOrder";
import BusinessTrigger from "@/components/reward/BusinessTrigger.vue";
import PointDialog from "@/components/activity/PointDialog.vue";
import { onMounted } from "vue";
import { showToast } from "@/utils/toastUtil";
import { ossStyleProcess } from "@/utils/tools";
import { UserInfoInputDialog } from "@/components/me/userInfoDialog";
import { isLogin } from "@/utils/authUtil";
import { useI18n } from "vue-i18n";
export default {
  __name: 'HomeView',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var userStore = useUserStore();
    var supplierStore = useSupplierStore();
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var _useOrder = useOrder(),
      toOrderViewPickup = _useOrder.toOrderViewPickup,
      toOrderViewDelivery = _useOrder.toOrderViewDelivery;
    var mainImgUrl = computed(function () {
      var _supplierStore$getSup;
      return (_supplierStore$getSup = supplierStore.getSupplierImageSetting) === null || _supplierStore$getSup === void 0 || (_supplierStore$getSup = _supplierStore$getSup.main_image) === null || _supplierStore$getSup === void 0 ? void 0 : _supplierStore$getSup.image_url;
    });
    var logoImgUrl = computed(function () {
      var _supplierStore$getSup2;
      return (_supplierStore$getSup2 = supplierStore.getSupplierImageSetting) === null || _supplierStore$getSup2 === void 0 || (_supplierStore$getSup2 = _supplierStore$getSup2.logo_image) === null || _supplierStore$getSup2 === void 0 ? void 0 : _supplierStore$getSup2.image_url;
    });
    var isDeliveryOn = computed(function () {
      return supplierStore.getIsSupplierSelfDeliverStatus;
    });
    var isPickupOn = computed(function () {
      return supplierStore.getIsSupplierSelfPickupStatus;
    });
    // 自配送跳转
    var handleSelfDelivery = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (isDeliveryOn.value) {
                _context.next = 3;
                break;
              }
              showToast(t("deliveryNotCurrentlySupported"), 2000);
              return _context.abrupt("return");
            case 3:
              toOrderViewDelivery();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleSelfDelivery() {
        return _ref.apply(this, arguments);
      };
    }();

    // const goToSelectAddress = () => {
    //   routerPush({
    //     name: "AddressList",
    //     query: {
    //       toName: "Menu",
    //       isForceGo: 1,
    //     },
    //   });
    // };

    // 自提跳转
    var handleSelfPickUp = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (isPickupOn.value) {
                _context2.next = 3;
                break;
              }
              showToast(t("selfPickupNotCurrentlySupported"), 2000);
              return _context2.abrupt("return");
            case 3:
              toOrderViewPickup();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleSelfPickUp() {
        return _ref2.apply(this, arguments);
      };
    }();
    var businessTrigger = ref(null);
    var showBannerTrigger = computed(function () {
      var _businessTrigger$valu;
      return (_businessTrigger$valu = businessTrigger.value) === null || _businessTrigger$valu === void 0 || (_businessTrigger$valu = _businessTrigger$valu.banner) === null || _businessTrigger$valu === void 0 ? void 0 : _businessTrigger$valu.is_open;
    });
    var showPointDialog = ref(false);
    onActivated(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _businessTrigger$valu2;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            userStore.setUserAsset();
            _context3.next = 3;
            return supplierStore.setBusinessTriggerList();
          case 3:
            businessTrigger.value = supplierStore.getBusinessTriggerList.find(function (item) {
              return item.trigger_type === "home_page";
            });
            showPointDialog.value = (_businessTrigger$valu2 = businessTrigger.value) === null || _businessTrigger$valu2 === void 0 || (_businessTrigger$valu2 = _businessTrigger$valu2.popup) === null || _businessTrigger$valu2 === void 0 ? void 0 : _businessTrigger$valu2.is_open;
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    var jumpToMyBalance = function jumpToMyBalance() {
      routerPush({
        name: "MyBalance"
      });
    };
    var jumpToRewards = function jumpToRewards() {
      var isMy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!isMy) {
        routerPush({
          name: "Rewards",
          query: {
            type: "redeem"
          }
        });
      } else {
        routerPush({
          name: "Rewards",
          query: {
            type: "my_rewards"
          }
        });
      }
    };
    var toMyCouponList = function toMyCouponList() {
      routerPush({
        name: "MyCouponList"
      });
    };
    var isInited = ref(false);
    onMounted(function () {
      setTimeout(function () {
        isInited.value = true;
      }, 30);

      // 配置了需要强制填写用户信息以及部分信息未填则弹窗
      if (supplierStore.getIsCollectCustomerInfo && isLogin() && (!userStore.getUserInfo.nickname || !userStore.getUserInfo.birthday || !userStore.getUserInfo.telephone)) {
        UserInfoInputDialog.open();
      }
    });
    var handleGoMemberQr = function handleGoMemberQr() {
      routerPush({
        name: "MemberQrCode"
      });
    };
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      return _openBlock(), _createBlock(StickyPowerBy, {
        class: "home-container"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [mainImgUrl.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "banner-img",
            src: mainImgUrl.value,
            alt: ""
          }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3)), _createElementVNode("div", {
            class: "info-code",
            onClick: handleGoMemberQr
          }, [_cache[4] || (_cache[4] = _createElementVNode("img", {
            class: "code",
            src: _imports_1,
            alt: ""
          }, null, -1)), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("memberQR")), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
            class: _normalizeClass(["method animation0", {
              enter: isInited.value
            }])
          }, [_createElementVNode("div", {
            class: _normalizeClass(["item delivery van-haptics-feedback", {
              'not-used': !isDeliveryOn.value
            }]),
            onClick: handleSelfDelivery
          }, [_unref(supplierStore).getSupplierDeliveryImage ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "img",
            src: _unref(supplierStore).getSupplierDeliveryImage,
            alt: ""
          }, null, 8, _hoisted_6)) : (_openBlock(), _createBlock(SvgIcon, {
            key: 1,
            class: "img",
            name: "delivery"
          })), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("orderDelivery")), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("enjoyOrdersEverywhere")), 1)], 2), _createElementVNode("div", {
            class: _normalizeClass(["item delivery van-haptics-feedback", {
              'not-used': !isPickupOn.value
            }]),
            onClick: handleSelfPickUp
          }, [_unref(supplierStore).getSupplierPickupImage ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "img",
            src: _unref(supplierStore).getSupplierPickupImage,
            alt: ""
          }, null, 8, _hoisted_9)) : (_openBlock(), _createBlock(SvgIcon, {
            key: 1,
            class: "img",
            name: "pickup"
          })), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("orderPickup")), 1), _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("skipTheQueue")), 1)], 2)], 2), _createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", {
            class: _normalizeClass(["user animation1", {
              enter: isInited.value
            }])
          }, [_createElementVNode("div", {
            class: "info",
            onClick: handleGoMemberQr
          }, [_createVNode(Image, {
            class: "avatar",
            src: _unref(userStore).user.avatar ? _unref(userStore).user.avatar : _unref(accountAvatar),
            alt: "",
            "oss-stylename": "type_5"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString(_unref(userStore).user.nickname), 1), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("member")), 1)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
            class: "item wallet",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return jumpToMyBalance();
            })
          }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_17, _toDisplayString(_unref(PriceStrCurrencySymbolEnum)[_unref(userStore).getWalletCurrency]), 1), _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(_unref(userStore).getWallet, _unref(userStore).getWalletCurrency, false)), 1)]), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("wallet")), 1)])]), _createElementVNode("div", {
            class: "item points",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return jumpToRewards();
            })
          }, [_createElementVNode("span", _hoisted_20, _toDisplayString(_unref(userStore).getPoints), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("points")), 1)]), _createElementVNode("div", {
            class: "item vouchers",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return toMyCouponList();
            })
          }, [_createElementVNode("span", _hoisted_22, _toDisplayString(_unref(userStore).getVouchers), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("vouchers")), 1)])])], 2), _createElementVNode("div", {
            class: _normalizeClass(["animation2", {
              enter: isInited.value
            }])
          }, [showBannerTrigger.value ? (_openBlock(), _createBlock(_component_Gap, {
            key: 0,
            h: 0.1
          })) : _createCommentVNode("", true), showBannerTrigger.value ? (_openBlock(), _createBlock(BusinessTrigger, {
            key: 1,
            class: "overflow-hidden",
            "business-trigger": businessTrigger.value
          }, null, 8, ["business-trigger"])) : _createCommentVNode("", true)], 2), _createVNode(_component_Gap, {
            h: 0.1
          }), _createVNode(LastestOrderPanel, {
            class: _normalizeClass(["animation3", {
              enter: isInited.value
            }])
          }, null, 8, ["class"]), logoImgUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("img", {
            alt: "",
            src: _unref(ossStyleProcess)(logoImgUrl.value, 'type_25')
          }, null, 8, _hoisted_25)])) : _createCommentVNode("", true)]), _createVNode(PointDialog, {
            visible: showPointDialog.value,
            "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
              return showPointDialog.value = $event;
            }),
            trigger: businessTrigger.value,
            "trigger-type": "home_page"
          }, null, 8, ["visible", "trigger"])];
        }),
        _: 1
      });
    };
  }
};